module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#rss",
      toString: function () {
        return this.url;
      }
    }